import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createSlots as _createSlots } from "vue";
const _hoisted_1 = {
  key: 1,
  class: "flex flex-col flex-1 pb-28 w-full h-full bg-white p-4"
};
const _hoisted_2 = {
  class: "flex justify-between items-center"
};
const _hoisted_3 = {
  class: "flex"
};
const _hoisted_4 = {
  class: "my-2 mx-4 no-print"
};
const _hoisted_5 = {
  class: "no-print my-2 mx-4"
};
const _hoisted_6 = {
  class: "text-base"
};
const _hoisted_7 = {
  class: "flex"
};
const _hoisted_8 = {
  class: "flex justify-between no-print"
};
const _hoisted_9 = {
  key: 0
};
const _hoisted_10 = {
  class: "fixed inset-0 z-50 overflow-x-hidden vue-modal-background"
};
const _hoisted_11 = {
  class: "bg-white w-72 shadow-lg border-opacity-10 rounded-sm absolute top-48 right-8"
};
const _hoisted_12 = {
  class: "p-3"
};
const _hoisted_13 = {
  class: "px-2 py-4 flex justify-between"
};
const _hoisted_14 = {
  key: 0,
  class: "overflow-y-auto flex-1 print:overflow-hidden"
};
const _hoisted_15 = {
  key: 0,
  class: "m-6 text-xs text-gray-800"
};
const _hoisted_16 = {
  key: 1,
  class: "inline-block print:inline py-2 min-w-full align-middle"
};
const _hoisted_17 = {
  class: "bar-border-bottom border-gray-200 shadow"
};
const _hoisted_18 = {
  class: "min-w-full divide-y divide-gray-200"
};
const _hoisted_19 = {
  class: "cursor-pointer sticky top-0 py-4 px-6 print:px-1 text-xs font-medium tracking-wider text-left text-gray-500 uppercase bg-gray-50"
};
const _hoisted_20 = {
  class: "cursor-pointer sticky top-0 py-4 px-6 print:px-1 text-xs font-medium tracking-wider text-left text-gray-500 uppercase bg-gray-50"
};
const _hoisted_21 = {
  class: "cursor-pointer sticky top-0 py-4 px-6 print:px-1 text-xs font-medium tracking-wider text-left text-gray-500 uppercase bg-gray-50"
};
const _hoisted_22 = {
  class: "cursor-pointer sticky top-0 py-4 px-6 print:px-1 text-xs font-medium tracking-wider text-left text-gray-500 uppercase bg-gray-50"
};
const _hoisted_23 = {
  class: "cursor-pointer sticky top-0 py-4 px-6 print:px-1 text-xs font-medium tracking-wider text-left text-gray-500 uppercase bg-gray-50"
};
const _hoisted_24 = {
  class: "py-3 px-6"
};
const _hoisted_25 = {
  class: "py-3 px-6"
};
const _hoisted_26 = {
  class: "py-3 px-6"
};
const _hoisted_27 = {
  class: "py-3 px-6"
};
const _hoisted_28 = {
  class: "py-3 px-6"
};
const _hoisted_29 = {
  class: "py-3 px-6"
};
const _hoisted_30 = {
  class: "py-3 px-6"
};
const _hoisted_31 = {
  class: "py-5"
};
const _hoisted_32 = {
  class: "flex justify-between no-print"
};
const _hoisted_33 = {
  class: "flex"
};
const _hoisted_34 = {
  class: "flex"
};
const _hoisted_35 = {
  class: "p-3 mt-3"
};
const _hoisted_36 = {
  class: "w-60 mt-3"
};
const _hoisted_37 = {
  class: "flex"
};
const _hoisted_38 = {
  key: 0,
  class: "pt-10"
};
const _hoisted_39 = {
  class: "w-6/12 divide-y divide-gray-200"
};
const _hoisted_40 = {
  key: 0
};
const _hoisted_41 = {
  class: "py-2 px-6 bar-border-top border-r border-b print:px-1 text-xs font-medium tracking-wider text-left text-gray-500 bg-gray-50"
};
const _hoisted_42 = {
  key: 1
};
const _hoisted_43 = {
  class: "py-2 px-6 bar-border-bottom border-r print:px-1 text-xs font-medium tracking-wider text-left text-gray-500 bg-gray-50"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_loader = _resolveComponent("loader");
  const _component_LlSecondaryButton = _resolveComponent("LlSecondaryButton");
  const _component_update_distributionModal = _resolveComponent("update-distributionModal");
  const _component_LlCheckbox = _resolveComponent("LlCheckbox");
  const _component_LlTooltip = _resolveComponent("LlTooltip");
  const _component_v_list_item = _resolveComponent("v-list-item");
  const _component_LlSelect = _resolveComponent("LlSelect");
  return $setup.loading ? (_openBlock(), _createBlock(_component_loader, {
    key: 0,
    what: 'Distribution Review',
    class: "mt-32"
  })) : (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("a", {
    onClick: _cache[0] || (_cache[0] = $event => $setup.sectionToggle('Distribution')),
    class: "inline-flex items-center space-x-1.5 text-sm font-medium text-gray-500 bg-transparent hover:text-gray-700 hover:no-underline cursor-pointer"
  }, [...(_cache[14] || (_cache[14] = [_createElementVNode("svg", {
    class: "w-5 h-5 text-gray-400",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true"
  }, [_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M7.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l2.293 2.293a1 1 0 010 1.414z",
    "clip-rule": "evenodd"
  })], -1), _createElementVNode("span", null, "Back", -1)]))])]), _createElementVNode("span", _hoisted_5, [_cache[15] || (_cache[15] = _createElementVNode("span", {
    class: "text-lg font-semibold"
  }, "Distribution Review: ", -1)), _createElementVNode("span", _hoisted_6, _toDisplayString($setup.selectedDistributions.label) + " (" + _toDisplayString(_ctx.formatDate($setup.getShortDateString($setup.selectedDistributions.date))) + ") ", 1)])]), _withDirectives(_createElementVNode("div", _hoisted_7, [_createVNode(_component_LlSecondaryButton, {
    type: "button",
    name: "export",
    class: "m-2",
    onClick: _cache[1] || (_cache[1] = $event => $setup.exportCSV())
  }, {
    default: _withCtx(() => [...(_cache[16] || (_cache[16] = [_createTextVNode(" Export ", -1)]))]),
    _: 1
  }), _createVNode(_component_LlSecondaryButton, {
    type: "button",
    name: "print",
    class: "my-2 ml-2",
    onClick: _cache[2] || (_cache[2] = $event => $setup.print())
  }, {
    default: _withCtx(() => [...(_cache[17] || (_cache[17] = [_createTextVNode(" Print ", -1)]))]),
    _: 1
  })], 512), [[_vShow, $setup.distributionDetail.users.length]])]), _withDirectives(_createElementVNode("div", _hoisted_8, [$setup.distributionNavigationStore.showUpdateDistributionModal ? (_openBlock(), _createBlock(_component_update_distributionModal, {
    key: 0
  })) : _createCommentVNode("", true), _cache[22] || (_cache[22] = _createElementVNode("span", null, null, -1)), _createElementVNode("div", null, [_createElementVNode("a", {
    onClick: _cache[3] || (_cache[3] = $event => $setup.showDialog = true),
    class: "cursor-pointer hover:no-underline font-semibold"
  }, "Payment Distribution Settings"), $setup.showDialog ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_cache[20] || (_cache[20] = _createElementVNode("h4", {
    class: "py-2 font-extrabold no-print"
  }, " Payment Distribution Settings ", -1)), _cache[21] || (_cache[21] = _createElementVNode("p", null, " You have the option to distribute part or all of the distribution. Selected items will be distributed as Bills in QuickBooks now. Unchecked items will be added to a new distribution list for the future. ", -1)), _createVNode(_component_LlCheckbox, {
    modelValue: $setup.newDistribution.share,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $setup.newDistribution.share = $event),
    label: "Worked Share"
  }, null, 8, ["modelValue"]), _createVNode(_component_LlCheckbox, {
    modelValue: $setup.newDistribution.origination,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $setup.newDistribution.origination = $event),
    label: "Origination"
  }, null, 8, ["modelValue"]), $setup.me.company.settings.report?.responsibleContribution ? (_openBlock(), _createBlock(_component_LlCheckbox, {
    key: 0,
    modelValue: $setup.newDistribution.responsible,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $setup.newDistribution.responsible = $event),
    label: "Responsible"
  }, null, 8, ["modelValue"])) : _createCommentVNode("", true), $setup.me.features.referral ? (_openBlock(), _createBlock(_component_LlCheckbox, {
    key: 1,
    modelValue: $setup.newDistribution.referral,
    "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => $setup.newDistribution.referral = $event),
    label: "Referral"
  }, null, 8, ["modelValue"])) : _createCommentVNode("", true), _createVNode(_component_LlCheckbox, {
    modelValue: $setup.newDistribution.expenses,
    "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => $setup.newDistribution.expenses = $event),
    label: "Expenses"
  }, null, 8, ["modelValue"]), _createElementVNode("div", _hoisted_13, [_createVNode(_component_LlSecondaryButton, {
    onClick: $setup.cancelDistributionSettings
  }, {
    default: _withCtx(() => [...(_cache[18] || (_cache[18] = [_createTextVNode(" Cancel ", -1)]))]),
    _: 1
  }, 8, ["onClick"]), _createVNode(_component_LlSecondaryButton, {
    color: "primary",
    onClick: _cache[9] || (_cache[9] = $event => $setup.applyDistributionSettings())
  }, {
    default: _withCtx(() => [...(_cache[19] || (_cache[19] = [_createTextVNode(" Save ", -1)]))]),
    _: 1
  })])])])])])) : _createCommentVNode("", true)])], 512), [[_vShow, $setup.distributionDetail.users.length]]), $setup.me.company ? (_openBlock(), _createElementBlock("div", _hoisted_14, [!$setup.distributionDetail.users.length ? (_openBlock(), _createElementBlock("div", _hoisted_15, " No payment in " + _toDisplayString($setup.selectedDistributions.label) + " (" + _toDisplayString(_ctx.formatDate($setup.getShortDateString($setup.selectedDistributions.date))) + ") ", 1)) : (_openBlock(), _createElementBlock("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createElementVNode("table", _hoisted_18, [_createElementVNode("thead", null, [_createElementVNode("tr", null, [_createElementVNode("th", _hoisted_19, _toDisplayString($setup.me.terms?.Lead), 1), _createElementVNode("th", _hoisted_20, [_cache[24] || (_cache[24] = _createTextVNode(" Worked Share ", -1)), _createVNode(_component_LlTooltip, {
    icon: "help"
  }, {
    default: _withCtx(() => [...(_cache[23] || (_cache[23] = [_createTextVNode("The user's share of Worked income based on their Working %", -1)]))]),
    _: 1
  })]), _withDirectives(_createElementVNode("th", _hoisted_21, " Origination ", 512), [[_vShow, $setup.showOrigination]]), _withDirectives(_createElementVNode("th", _hoisted_22, " Responsible ", 512), [[_vShow, $setup.showOrigination && $setup.me.company.settings.report?.responsibleContribution]]), _withDirectives(_createElementVNode("th", _hoisted_23, " Referrals ", 512), [[_vShow, $setup.me.features.referral]]), _cache[25] || (_cache[25] = _createElementVNode("th", {
    class: "cursor-pointer sticky top-0 py-4 px-6 print:px-1 text-xs font-medium tracking-wider text-left text-gray-500 uppercase bg-gray-50"
  }, " Expenses ", -1)), _cache[26] || (_cache[26] = _createElementVNode("th", {
    class: "cursor-pointer sticky top-0 py-4 px-6 print:px-1 text-xs font-medium tracking-wider text-left text-gray-500 uppercase bg-gray-50"
  }, " Total ", -1))])]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.distributionDetail.users, (user, idx) => {
    return _openBlock(), _createElementBlock("tbody", {
      class: "attorney-revenue-reports-row",
      key: idx
    }, [_createElementVNode("tr", null, [_createElementVNode("td", _hoisted_24, _toDisplayString(user.user.name), 1), _createElementVNode("td", _hoisted_25, _toDisplayString(_ctx.formatCurrency(user.data.origination.share)), 1), _withDirectives(_createElementVNode("td", {
      class: "py-3 px-6"
    }, _toDisplayString(_ctx.formatCurrency(user.data.origination.originatorDebit)), 513), [[_vShow, $setup.showOrigination]]), _withDirectives(_createElementVNode("td", {
      class: "py-3 px-6"
    }, _toDisplayString(_ctx.formatCurrency(user.data.origination.responsibleDebit)), 513), [[_vShow, $setup.showOrigination && $setup.me.company.settings.report?.responsibleContribution]]), _withDirectives(_createElementVNode("td", {
      class: "py-3 px-6"
    }, _toDisplayString(_ctx.formatCurrency(user.data.origination.referralDebit)), 513), [[_vShow, $setup.me.features.referral]]), _createElementVNode("td", _hoisted_26, _toDisplayString(_ctx.formatCurrency(user.data.collected.expensesUsers)), 1), _createElementVNode("td", _hoisted_27, _toDisplayString(_ctx.formatCurrency(user.data.collected.distributionSummaryTotal)), 1)])]);
  }), 128)), _createElementVNode("tfoot", null, [_createElementVNode("tr", null, [_cache[27] || (_cache[27] = _createElementVNode("td", {
    class: "py-3 px-6 font-bold"
  }, "Total", -1)), _createElementVNode("td", _hoisted_28, _toDisplayString(_ctx.formatCurrency($setup.distributionDetail.data.origination.share)), 1), _withDirectives(_createElementVNode("td", {
    class: "py-3 px-6"
  }, _toDisplayString(_ctx.formatCurrency($setup.distributionDetail.data.origination.originatorDebit)), 513), [[_vShow, $setup.showOrigination]]), _withDirectives(_createElementVNode("td", {
    class: "py-3 px-6"
  }, _toDisplayString(_ctx.formatCurrency($setup.distributionDetail.data.origination.responsibleDebit)), 513), [[_vShow, $setup.showOrigination && $setup.me.company.settings.report?.responsibleContribution]]), _withDirectives(_createElementVNode("td", {
    class: "py-3 px-6"
  }, _toDisplayString(_ctx.formatCurrency($setup.distributionDetail.data.origination.referralDebit)), 513), [[_vShow, $setup.me.features.referral]]), _createElementVNode("td", _hoisted_29, _toDisplayString(_ctx.formatCurrency($setup.distributionDetail.data.collected.expensesUsers)), 1), _createElementVNode("td", _hoisted_30, _toDisplayString(_ctx.formatCurrency($setup.distributionDetail.data.collected.distributionSummaryTotal)), 1)])])])]), _withDirectives(_createElementVNode("div", _hoisted_31, [_createElementVNode("div", _hoisted_32, [_createElementVNode("div", _hoisted_33, [_withDirectives(_createElementVNode("div", _hoisted_34, [_createElementVNode("div", _hoisted_35, " Save " + _toDisplayString($setup.saveForFutureInfo) + " to a future Distribution ", 1), _createElementVNode("div", _hoisted_36, [_createVNode(_component_LlSelect, {
    modelValue: $setup.newDistribution.distributionId,
    "onUpdate:modelValue": [_cache[10] || (_cache[10] = $event => $setup.newDistribution.distributionId = $event), $setup.distributionChange],
    items: $setup.distributionStore.getNonDistributedDistribution,
    "item-value": "value",
    "return-object": false,
    placeholder: "Select Distribution",
    "is-autocomplete": true,
    clearable: true,
    "hide-details": true
  }, {
    "no-data": _withCtx(() => [_createVNode(_component_v_list_item, {
      title: "Create New Distribution"
    })]),
    _: 1
  }, 8, ["modelValue", "items", "onUpdate:modelValue"])]), _createVNode(_component_LlSecondaryButton, {
    class: "m-2",
    onClick: _cache[11] || (_cache[11] = $event => $setup.distributionNavigationStore.toggleUpdateDistributionModal(true, null))
  }, {
    default: _withCtx(() => [...(_cache[28] || (_cache[28] = [_createTextVNode(" Create Distribution ", -1)]))]),
    _: 1
  })], 512), [[_vShow, $setup.saveForFutureInfo]])]), _createElementVNode("div", _hoisted_37, [_createVNode(_component_LlSecondaryButton, {
    type: "button",
    name: "export",
    class: "m-2",
    onClick: _cache[12] || (_cache[12] = $event => $setup.changeStatus())
  }, {
    default: _withCtx(() => [_createTextVNode(" Set to " + _toDisplayString($setup.selectedDistributions.status === "Distributed" ? "Draft" : "Distributed"), 1)]),
    _: 1
  }), _createVNode(_component_LlTooltip, null, _createSlots({
    activator: _withCtx(() => [_createVNode(_component_LlSecondaryButton, {
      type: "button",
      name: "export",
      class: "m-2",
      color: $setup.selectedDistributions.status !== 'Distributed' ? 'primary' : undefined,
      disabled: !$setup.me.company.settings.distribution?.account?.id || $setup.distributionStore.saving,
      onClick: _cache[13] || (_cache[13] = $event => $setup.sendToQuickBooks())
    }, {
      default: _withCtx(() => [...(_cache[29] || (_cache[29] = [_createTextVNode(" Send to QuickBooks ", -1)]))]),
      _: 1
    }, 8, ["color", "disabled"])]),
    _: 2
  }, [!$setup.me.company.settings.distribution?.account?.id ? {
    name: "default",
    fn: _withCtx(() => [_cache[30] || (_cache[30] = _createElementVNode("span", null, "You have not enabled your settings to send distribution to QuickBooks Online. Please navigate to your QuickBooks in LeanLaw to configure how distribution are sent to QuickBooks.", -1))]),
    key: "0"
  } : undefined]), 1024)])])], 512), [[_vShow, $setup.distributionDetail.users]]), $setup.distributionDetail?.unallocated?.collected.expensesUnassigned || _ctx.data?.unallocated?.collected.servicesUnassigned ? (_openBlock(), _createElementBlock("div", _hoisted_38, [_cache[33] || (_cache[33] = _createElementVNode("h3", null, "Unallocated Revenue", -1)), _createElementVNode("table", _hoisted_39, [_createElementVNode("tbody", null, [$setup.distributionDetail?.unallocated?.collected.expensesUnassigned != 0 ? (_openBlock(), _createElementBlock("tr", _hoisted_40, [_cache[31] || (_cache[31] = _createElementVNode("td", {
    class: "py-2 px-6 bar-border-top border-l border-b print:px-1 text-xs font-medium tracking-wider text-left text-gray-500 bg-gray-50"
  }, " Unallocated Expenses ", -1)), _createElementVNode("td", _hoisted_41, _toDisplayString(_ctx.formatCurrency($setup.distributionDetail?.unallocated?.collected.expensesUnassigned)), 1)])) : _createCommentVNode("", true), $setup.distributionDetail?.unallocated?.collected.servicesUnassigned != 0 ? (_openBlock(), _createElementBlock("tr", _hoisted_42, [_cache[32] || (_cache[32] = _createElementVNode("td", {
    class: "py-2 px-6 bar-border-bottom border-l print:px-1 text-xs font-medium tracking-wider text-left text-gray-500 bg-gray-50"
  }, " Unallocated Services ", -1)), _createElementVNode("td", _hoisted_43, _toDisplayString(_ctx.formatCurrency($setup.distributionDetail?.unallocated?.collected.servicesUnassigned)), 1)])) : _createCommentVNode("", true)])])])) : _createCommentVNode("", true)]))])) : _createCommentVNode("", true)]));
}